module.exports = __webpack_public_path__ + "static/chronurgy_wizard-a08fb8591fd1b856a059046e78b8703e.png";